const FLAG_OFFSET = 0x1f1a5;

export const getFlagEmoji = (countryCode: string): string =>
  countryCode
    .toUpperCase()
    .split('')
    .map(char => String.fromCodePoint(char.charCodeAt(0) + FLAG_OFFSET))
    .join('');
